import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, share } from "rxjs";
import { ApiDataService } from "src/app/api/services/api-data.service";
import { CompetitionRegistration } from "../models/competition-registration.interface";
import { SelectedItem } from "src/app/controls/models/selected-item.interface";
import { CompetitionRegistrationCrew } from "../models/competition-registration-crew.interface";
import { CompetitionRegistrationPrefill } from "../models/competition-registration-prefill.interface";
import { CompetitionRegistrationCreate } from "../models/competition-registration-create.interface";

@Injectable({
    providedIn: 'root'
})
export class CompetitionRegistrationService {

    private service = inject(ApiDataService);

    /** Grid reload emit reference */
    public reload = new BehaviorSubject<void>(undefined);

    /** @inheritdoc */
    public getCompetitionRegistration(competitionRegistrationId: number): Observable<CompetitionRegistration> {
        return this.service.get<CompetitionRegistration>('competition-registrations/get/' + competitionRegistrationId);
    }

    /** @inheritdoc */
    public getCrews(competitionId: number): Observable<SelectedItem[]> {
        return this.service.getAll<SelectedItem>('annual-registrations/crews/' + competitionId).pipe(share());
    }

    public getCompetitors(crewId: number): Observable<CompetitionRegistrationCrew> {
        return this.service.get<CompetitionRegistrationCrew>('crews/registration/' + crewId);
    }

    public getDataForPrefill(competitionId: number): Observable<CompetitionRegistrationPrefill> {
        return this.service.get<CompetitionRegistrationPrefill>('competition-registrations/get-data/' + competitionId);
    }

    public getOrganizerDataForPrefill(competitionId: number): Observable<CompetitionRegistrationPrefill> {
        return this.service.get<CompetitionRegistrationPrefill>('competition-registrations/get-organizer-data/' + competitionId);
    }

    public create(data: CompetitionRegistrationCreate): Observable<boolean> {
        return this.service.post<boolean>('competition-registrations/create', data);
    }

    public update(data: CompetitionRegistrationCreate): Observable<boolean> {
        return this.service.put<boolean>('competition-registrations/update', data);
    }

    public delete(id: number): Observable<boolean> {
        return this.service.delete<boolean>('competition-registrations', id);
    }

}